import { render, staticRenderFns } from "./AppAside.vue?vue&type=template&id=950359b6&scoped=true&"
import script from "./AppAside.vue?vue&type=script&lang=js&"
export * from "./AppAside.vue?vue&type=script&lang=js&"
import style0 from "./AppAside.vue?vue&type=style&index=0&id=950359b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950359b6",
  null
  
)

export default component.exports